import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../../../api/services/auth.service';
import { MarketService } from '../../../api/services/market.service';
import { UserService } from '../../../api/services/user.service';
import { ReportService } from '../../../api/services/report.services';
import { ProjectService } from '../../../api/services/project.services';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { Market } from '../../../api/models/market-model';
import { Organization } from '../../../api/models/organization';
import { RoleRequest } from '../../../api/models/role-assignment-map';
import { User } from '../../../api/models/user-model';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { PaginatedRequest } from '../../../api/models/paginated-request';
import { taskStatusReportRequest } from '../../../api/models/project-summary';
import { TaskStatusHistory, TaskStatusReport } from '../../../api/models/task-report';
import { Project, PaginatedProjectDTO, ProjectUserInput, AllProject } from '../../../api/models/project-model';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { AnalyticsService } from '../../../api/services/analytics.service';

@Component({
    selector: 'app-taskstatus-report',
    templateUrl: './taskstatus-report.component.html',
    styleUrls: ['./taskstatus-report.component.scss']
})
export class TaskStatusReportComponent implements OnInit {

    roleRequest: RoleRequest;
    isTesscoAdmin: boolean;
    isClientAdmin: boolean;
    organizations: Organization[] = [];
    allMarkets: Market[] = [];
    marketsFiltered: Market[] = [];
    selectedOrgId = '';
    accountNumber: string;
    selectedMarket : Market;
    selectedAccountNumber:string;
    selectedLocationCode:string;
    loading = true;
    page = 1;
    pageSize = 20;
    totalRecords = 0;
    sorting: string = "date_opened,desc";
    noTaskMessage = ['There are no tasks to display for this market.'];
    paginatedRequest: PaginatedRequest;
    projectPaginatedRequest : PaginatedRequest;
    taskStatusReport: TaskStatusHistory = new TaskStatusHistory();
    showTaskSearchOption:boolean=false;
    showNoTaskMessage = false;
    errorMessage: string[] = [];
    reportFilterSearchValue:string = '';
    reportFilterKeyValue:string = 'worksheetName';
    tempOrders: TaskStatusReport[];

    blob: any;
    excelLoading: boolean = false;
    excelBtnDisabled: boolean = false;

    projectList: PaginatedProjectDTO;
    projectUserInput: ProjectUserInput;
    projects: Project[] = [];
    fetchedProjectIds = [];
    selectedProject: Project;
    selectedProjectId:string;
    selectedProjectName:string;
    selectedTaskType: string = 'ALL';
    
    sortDirection: string;
    wsNameSortDirection = '';
    oraclePrNumberSortDirection = '';
    projectNameSortDirection = '';
    initBySortDirection = '';
    orderNoSortDirection = '';
    purchaseNoSortDirection = '';
    creationDateSortDirection = '';
    closureDateSortDirection='';
    daysSortDirection = '';
    closedBySortDirection = '';
    statusSortDirection = '';
    @ViewChild('accordion') accordion: NgbAccordion;

    minDate: NgbDateStruct;
    maxDate: NgbDateStruct;
    startDate;
    endDate;
    taskRequest:taskStatusReportRequest;

    

    constructor(
        private authService: AuthService,
        private userService: UserService,
        private marketService: MarketService,
        private toastr: ToastrService,
        private reportService: ReportService,
        private projectService : ProjectService,
        public datePipe: DatePipe,
        private analyticsService: AnalyticsService
    ) { }

    ngOnInit() {
        this.setInitialMinAndMaxDate();
        this.roleRequest = new RoleRequest('ADMIN_TESSCO', null);
        this.roleRequest.setRoleAndContextMap('ADMIN_CLIENT', null);
        this.authService.getUserRoles(this.roleRequest).subscribe(roles => {
            this.isTesscoAdmin = roles.getRoleMap('ADMIN_TESSCO');
            this.isClientAdmin = roles.getRoleMap('ADMIN_CLIENT');
        });
        forkJoin(this.userService.findUserById(this.authService.getUserId()), this.userService.getOrganizations())
            .subscribe((data: [User, Organization[]]) => {
                let currentOrgId = data[0]['Organization ID'];
                this.selectedOrgId = currentOrgId;
                this.organizations = data[1];
                this.marketService.getMarketsByOrgId(currentOrgId).subscribe(markets => {
                    this.allMarkets = markets;
                    this.allMarkets = this.allMarkets.filter(mkt => this.userService.isMarketPermittedForCurrentUser(mkt.id));
                    this.marketsFiltered = this.allMarkets;
                    if(this.marketsFiltered.length > 0){
                        this.selectedMarket = this.marketsFiltered[0];
                        this.selectedAccountNumber = this.selectedMarket.accountNumber;
                        this.getProjects();
                    }else{
                        this.noTaskMessage = ['There are no markets for this organization.'];
                        this.loading = false;
                        this.totalRecords = 0;
                        this.marketsFiltered = [];
                        this.showNoTaskMessage = true;
                        this.showTaskSearchOption = false;
                        this.excelBtnDisabled = true;
                    }
                });
            });
        
    }

    changeOrg(organizationId: string) {
        this.selectedOrgId = organizationId;
        this.loading = true;
        this.errorMessage = [];
        this.marketService.getMarketsByOrgId(this.selectedOrgId).subscribe(markets => {
            if(markets.length>0){
                this.showNoTaskMessage = false;
                this.showTaskSearchOption = false;
                this.excelBtnDisabled = true;
                this.marketsFiltered = markets;
                this.marketsFiltered = this.marketsFiltered.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
                this.selectedMarket = this.marketsFiltered[0];
                this.selectedAccountNumber = this.marketsFiltered[0].accountNumber;
                this.getProjects();
            }else{
                this.noTaskMessage = ['There are no markets for this organization.'];
                this.loading = false;
                this.totalRecords = 0;
                this.taskStatusReport.records = [];
                this.marketsFiltered = [];
                this.showNoTaskMessage = true;
                this.showTaskSearchOption = false;
                this.excelBtnDisabled = true;
            }
        });
    }

    changeMarket(index){
        this.errorMessage = [];
        this.loading = true;
        this.totalRecords = 0;
        this.page = 1;
        this.showNoTaskMessage = true;
        this.showTaskSearchOption = false;
        this.excelBtnDisabled = true;
        this.selectedMarket = this.marketsFiltered[index];
        this.getProjects();  
    }

    changeProject(index){
        this.errorMessage = [];
        this.loading = true;
        this.totalRecords = 0;
        this.page = 1;
        this.showNoTaskMessage = true;
        this.showTaskSearchOption = false;
        this.excelBtnDisabled = true;
        this.selectedProject = this.projects[index];
        if (this.isTesscoAdmin || this.isClientAdmin) {
            this.selectedProjectId = this.selectedProject.id;
        } else if (this.selectedProject.id === "ALL") {
            this.selectedProjectId = this.fetchedProjectIds.join(',');
        } else {
            this.selectedProjectId = this.selectedProject.id;
        }
        this.selectedProjectName = this.selectedProject.name;
        this.loadPage(this.page,this.selectedAccountNumber,this.selectedMarket.id,this.selectedMarket.name,this.selectedProjectId,this.selectedProjectName,this.selectedTaskType);  
    }

    getProjects(){
        this.projectPaginatedRequest = new PaginatedRequest(1, 1000, "");
        this.projectUserInput = new ProjectUserInput(this.authService.getUserId(), true, "Active");
        this.projectService.getMyProjects(this.selectedMarket.id, this.projectUserInput, this.projectPaginatedRequest).subscribe(paginatedProjectDTO => {
            this.projectList = paginatedProjectDTO;
            if (this.projectList.totalRecords && this.projectList.totalRecords > 0) {
                this.projectList.records = this.projectList.records.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
                let allProject = new Project();
                allProject.id = "ALL";
                allProject.name = "ALL";
                this.fetchedProjectIds = this.projectList.records.map(proj => proj.id);
                // Adding ALL option as first element in the Array
                this.projectList.records.unshift(allProject);
                this.projects = this.projectList.records;
                this.selectedProject = this.projects[0];
                if (this.isTesscoAdmin || this.isClientAdmin) {
                    this.selectedProjectId = this.selectedProject.id;
                } else if (this.selectedProject.id === "ALL") {
                    this.selectedProjectId = this.fetchedProjectIds.join(',');
                } else {
                    this.selectedProjectId = this.selectedProject.id;
                }
                this.selectedProjectName = this.selectedProject.name;
                this.loadPage(this.page,this.selectedAccountNumber,this.selectedMarket.id,this.selectedMarket.name,this.selectedProjectId,this.selectedProjectName,"ALL");
            }else{
                this.projects = [];
                this.taskStatusReport.records = [];
                this.noTaskMessage =['There are no projects for this market']
                this.showNoTaskMessage = true;
                this.excelBtnDisabled = true;
                this.loading = false;
            }
        }, error => {
            
        });  
    }

    loadPage(page,customerNumber:string,marketId:string,marketName:string,projectId:string,projectName:string,taskName:string,reportFilterKey?:string,reportFilterValue?:string){
        this.loading = true;
        this.paginatedRequest = new PaginatedRequest(page, this.pageSize,this.sorting);
        this.taskRequest = this.setInputValues(customerNumber,marketId,marketName,projectId,projectName,taskName);
        this.reportService.getTaskStatusReport(this.taskRequest,this.paginatedRequest,reportFilterKey,reportFilterValue).subscribe(items => {
            this.loading = false;
            this.taskStatusReport = items;
            if (this.taskStatusReport.totalRecords && this.taskStatusReport.totalRecords > 0) {
                this.totalRecords = this.taskStatusReport.totalRecords;
                this.showTaskSearchOption = true;
                this.excelBtnDisabled = false;
                this.showNoTaskMessage = false;
                if (!this.taskStatusReport || !this.taskStatusReport.records || this.taskStatusReport.records.length < 1) {
                    this.showNoTaskMessage = true;
                    this.showTaskSearchOption = false;
                    this.excelBtnDisabled = true;
                    this.taskStatusReport.records = [];
                    this.noTaskMessage = ['There are no tasks to display'];
                }
            } else {
                this.totalRecords = 0;
                this.loading = false;
                this.taskStatusReport.records = [];
                this.noTaskMessage = ['There are no tasks to display'];
                this.showNoTaskMessage = true;
                this.excelBtnDisabled = true;
            }
            this.sendDataToAnalytics();
        }, error => {
            this.errorMessage.push(error.error.message);
            this.showNoTaskMessage = true;
            this.showTaskSearchOption = false;
            this.excelBtnDisabled = true;
            this.taskStatusReport.records = [];
            this.totalRecords = 0;
            this.loading = false;
        });
    }

    private sendDataToAnalytics() {
        this.analyticsService.trackReportSearch('task_status_report');
    }

    onEnteringSearchValue(value) {
        this.reportFilterSearchValue = value;
    }

    filterTaskStatusReport() {
        this.showNoTaskMessage = false;
        this.page = 1;
        if(this.reportFilterSearchValue.trim() != ''){
            this.loadPage(this.page,this.selectedAccountNumber,this.selectedMarket.id,this.selectedMarket.name,this.selectedProjectId,this.selectedProjectName,this.selectedTaskType,this.reportFilterKeyValue,this.reportFilterSearchValue);
        }else{
            this.loadPage(this.page,this.selectedAccountNumber,this.selectedMarket.id,this.selectedMarket.name,this.selectedProjectId,this.selectedProjectName,this.selectedTaskType);
        }
        
    }

    setTaskType(taskType: string) {
        this.errorMessage = [];
        this.loading = true;
        this.totalRecords = 0;
        this.page = 1;
        this.showNoTaskMessage = true;
        this.showTaskSearchOption = false;
        this.excelBtnDisabled = true;
        this.selectedTaskType = taskType;
        this.loadPage(this.page,this.selectedAccountNumber,this.selectedMarket.id,this.selectedMarket.name,this.selectedProjectId,this.selectedProjectName,this.selectedTaskType);
      }

    sortColumns(n: number) {
        if (n == 1) {
            this.sortWorksheetName();
        }else if (n == 2) {
            this.sortOracleProjectNumber();
        } else if (n == 3) {
            this.sortProjectName();
        } else if (n == 4) {
            this.sortInitiatedBy();
        } else if (n == 5) {
            this.sortOrderNumber();
        }else if (n == 6) {
            this.sortTaskCreationDate();
        }else if (n == 7) {
            this.sortTaskClosureDate;
        } else if (n == 8) {
            this.sortClosedByDays();
        } else if (n == 9) {
            this.sortClosedBy();
        } else if (n == 10) {
            this.sortStatus();
        }
    }



    sortTable(n: number) {
        this.sortColumns(n);
        var tempSortDir = this.sortDirection;
        if (this.sortDirection === '') {
            this.taskStatusReport.records = JSON.parse(JSON.stringify(this.tempOrders));
        }
        if (this.taskStatusReport.records && this.taskStatusReport.records.length) {
            var orderArray = this.taskStatusReport.records
            orderArray.sort(function (a, b) {
                let keyA, keyB;
                if (n == 1) {
                    keyA = a.worksheetName.toUpperCase();
                    keyB = b.worksheetName.toUpperCase();
                }else if (n == 2) {
                    keyA = a.oracleProjectNumber;
                    keyB = b.oracleProjectNumber;
                } else if (n == 3) {
                    keyA = a.projectName.toUpperCase();
                    keyB = b.projectName.toUpperCase();
                } else if (n == 4) {
                    keyA = a.initiatorName;
                    keyB = b.initiatorName;
                } else if (n == 5) {
                    keyA = a.orderNumber;
                    keyB = b.orderNumber;
                } else if (n == 6) {
                    keyA = new Date(a.creationDate);
                    keyB = new Date(b.creationDate);
                }else if (n == 7) {
                    keyA = new Date(a.closureDate);
                    keyB = new Date(b.closureDate);
                } else if (n == 8) {
                    keyA = a.daysToClosure;
                    keyB = b.daysToClosure;
                } else if (n == 9) {
                    keyA = a.closedBy
                    keyB = b.closedBy
                } else if (n == 10) {
                    keyA = a.status;
                    keyB = b.status;
                }

                if (tempSortDir == 'asc') {
                    if (keyA < keyB) return -1;
                    if (keyA > keyB) return 1;
                    return 0;
                } else if (tempSortDir == 'desc') {
                    if (keyA < keyB) return 1;
                    if (keyA > keyB) return -1;
                    return 0;
                }
            });
            this.taskStatusReport.records = orderArray;
        }
    }

    sortProjectName() {
        if (this.projectNameSortDirection === '') {
            this.projectNameSortDirection = 'asc';
        } else if (this.projectNameSortDirection === 'asc') {
            this.projectNameSortDirection = 'desc';
        } else {
            this.projectNameSortDirection = '';
        }
        this.sortDirection = this.projectNameSortDirection;
        this.wsNameSortDirection = '';
        this.oraclePrNumberSortDirection = '';
        this.initBySortDirection = '';
        this.orderNoSortDirection = '';
        this.purchaseNoSortDirection = '';
        this.creationDateSortDirection = '';
        this.closureDateSortDirection='';
        this.daysSortDirection = '';
        this.closedBySortDirection = '';
        this.statusSortDirection = '';
    }

    sortWorksheetName() {
        if (this.wsNameSortDirection === '') {
            this.wsNameSortDirection = 'asc';
        } else if (this.wsNameSortDirection === 'asc') {
            this.wsNameSortDirection = 'desc';
        } else {
            this.wsNameSortDirection = '';
        }
        this.sortDirection = this.wsNameSortDirection;
        this.projectNameSortDirection = '';
        this.oraclePrNumberSortDirection = '';
        this.initBySortDirection = '';
        this.orderNoSortDirection = '';
        this.purchaseNoSortDirection = '';
        this.creationDateSortDirection = '';
        this.closureDateSortDirection='';
        this.daysSortDirection = '';
        this.closedBySortDirection = '';
        this.statusSortDirection = '';
    }

    sortOracleProjectNumber() {
        if (this.oraclePrNumberSortDirection === '') {
            this.oraclePrNumberSortDirection = 'asc';
        } else if (this.oraclePrNumberSortDirection === 'asc') {
            this.oraclePrNumberSortDirection = 'desc';
        } else {
            this.oraclePrNumberSortDirection = '';
        }
        this.sortDirection = this.oraclePrNumberSortDirection;
        this.projectNameSortDirection = '';
        this.wsNameSortDirection = '';
        this.initBySortDirection = '';
        this.orderNoSortDirection = '';
        this.purchaseNoSortDirection = '';
        this.creationDateSortDirection = '';
        this.closureDateSortDirection='';
        this.daysSortDirection = '';
        this.closedBySortDirection = '';
        this.statusSortDirection = '';
    }

    sortInitiatedBy() {
        if (this.initBySortDirection === '') {
            this.initBySortDirection = 'asc';
        } else if (this.initBySortDirection === 'asc') {
            this.initBySortDirection = 'desc';
        } else {
            this.initBySortDirection = '';
        }
        this.sortDirection = this.initBySortDirection;
        this.projectNameSortDirection = '';
        this.wsNameSortDirection = '';
        this.oraclePrNumberSortDirection = '';
        this.orderNoSortDirection = '';
        this.purchaseNoSortDirection = '';
        this.creationDateSortDirection = '';
        this.closureDateSortDirection='';
        this.daysSortDirection = '';
        this.closedBySortDirection = '';
        this.statusSortDirection = '';
    }

    sortOrderNumber() {
        if (this.orderNoSortDirection === '') {
            this.orderNoSortDirection = 'asc';
        } else if (this.orderNoSortDirection === 'asc') {
            this.orderNoSortDirection = 'desc';
        } else {
            this.orderNoSortDirection = '';
        }
        this.sortDirection = this.orderNoSortDirection;
        this.projectNameSortDirection = '';
        this.wsNameSortDirection = '';
        this.oraclePrNumberSortDirection = '';
        this.initBySortDirection = '';
        this.purchaseNoSortDirection = '';
        this.creationDateSortDirection = '';
        this.closureDateSortDirection='';
        this.daysSortDirection = '';
        this.closedBySortDirection = '';
        this.statusSortDirection = '';
    }

    sortPurchaseOrderNumber() {
        if (this.purchaseNoSortDirection === '') {
            this.purchaseNoSortDirection = 'asc';
        } else if (this.purchaseNoSortDirection === 'asc') {
            this.purchaseNoSortDirection = 'desc';
        } else {
            this.purchaseNoSortDirection = '';
        }
        this.sortDirection = this.purchaseNoSortDirection;
        this.projectNameSortDirection = '';
        this.wsNameSortDirection = '';
        this.oraclePrNumberSortDirection = '';
        this.orderNoSortDirection = '';
        this.creationDateSortDirection = '';
        this.closureDateSortDirection='';
        this.daysSortDirection = '';
        this.closedBySortDirection = '';
        this.statusSortDirection = '';
    }

    sortTaskCreationDate() {
        if (this.creationDateSortDirection === '') {
            this.creationDateSortDirection = 'asc';
        } else if (this.creationDateSortDirection === 'asc') {
            this.creationDateSortDirection = 'desc';
        } else {
            this.creationDateSortDirection = '';
        }
        this.sortDirection = this.creationDateSortDirection;
        this.projectNameSortDirection = '';
        this.wsNameSortDirection = '';
        this.oraclePrNumberSortDirection = '';
        this.initBySortDirection = '';
        this.orderNoSortDirection = '';
        this.purchaseNoSortDirection = '';
        this.closureDateSortDirection='';
        this.daysSortDirection = '';
        this.closedBySortDirection = '';
        this.statusSortDirection = '';
    }

    sortTaskClosureDate() {
        if (this.closureDateSortDirection === '') {
            this.closureDateSortDirection = 'asc';
        } else if (this.closureDateSortDirection === 'asc') {
            this.closureDateSortDirection = 'desc';
        } else {
            this.closureDateSortDirection = '';
        }
        this.sortDirection = this.closureDateSortDirection;
        this.projectNameSortDirection = '';
        this.wsNameSortDirection = '';
        this.oraclePrNumberSortDirection = '';
        this.initBySortDirection = '';
        this.orderNoSortDirection = '';
        this.purchaseNoSortDirection = '';
        this.creationDateSortDirection = '';
        this.daysSortDirection = '';
        this.closedBySortDirection = '';
        this.statusSortDirection = '';
    }

    sortClosedByDays() {
        if (this.daysSortDirection === '') {
            this.daysSortDirection = 'asc';
        } else if (this.daysSortDirection === 'asc') {
            this.daysSortDirection = 'desc';
        } else {
            this.daysSortDirection = '';
        }
        this.sortDirection = this.daysSortDirection;
        this.projectNameSortDirection = '';
        this.wsNameSortDirection = '';
        this.oraclePrNumberSortDirection = '';
        this.initBySortDirection = '';
        this.orderNoSortDirection = '';
        this.purchaseNoSortDirection = '';
        this.creationDateSortDirection = '';
        this.closureDateSortDirection='';
        this.closedBySortDirection = '';
        this.statusSortDirection = '';
    }

    sortClosedBy() {
        if (this.closedBySortDirection === '') {
            this.closedBySortDirection = 'asc';
        } else if (this.closedBySortDirection === 'asc') {
            this.closedBySortDirection = 'desc';
        } else {
            this.closedBySortDirection = '';
        }
        this.sortDirection = this.closedBySortDirection;
        this.projectNameSortDirection = '';
        this.wsNameSortDirection = '';
        this.oraclePrNumberSortDirection = '';
        this.initBySortDirection = '';
        this.orderNoSortDirection = '';
        this.purchaseNoSortDirection = '';
        this.creationDateSortDirection = '';
        this.closureDateSortDirection='';
        this.daysSortDirection = '';
        this.statusSortDirection = '';
    }

    sortStatus() {
        if (this.statusSortDirection === '') {
            this.statusSortDirection = 'asc';
        } else if (this.statusSortDirection === 'asc') {
            this.statusSortDirection = 'desc';
        } else {
            this.statusSortDirection = '';
        }
        this.sortDirection = this.statusSortDirection;
        this.projectNameSortDirection = '';
        this.wsNameSortDirection = '';
        this.oraclePrNumberSortDirection = '';
        this.initBySortDirection = '';
        this.orderNoSortDirection = '';
        this.purchaseNoSortDirection = '';
        this.creationDateSortDirection = '';
        this.closureDateSortDirection='';
        this.daysSortDirection = '';
        this.closedBySortDirection = '';
    }

    downloadXls() {
        this.excelLoading = true;
        this.excelBtnDisabled = true;
        this.taskRequest = this.setInputValues(this.selectedAccountNumber, this.selectedMarket.id,
            this.selectedMarket.name, this.selectedProjectId, this.selectedProjectName,
            this.selectedTaskType);
        this.reportService.downloadTaskStatusReport(this.taskRequest).subscribe((resp) => {
          const fileName = resp.headers.get('filename') ? resp.headers.get('filename') : 'Task_Status_'+this.selectedMarket.name+'_'+ new Date();
          const data = resp.body;
          this.blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          var downloadUrl = window.URL.createObjectURL(data);
          var link = document.createElement('a');
          link.href = downloadUrl;
          link.download = fileName + '.xlsx';
          link.click();
          this.excelLoading = false;
          this.excelBtnDisabled = false;
        }, error => {
          this.onError("Error downloading the file!!!");
          this.excelLoading = false;
          this.excelBtnDisabled = false;
        });
    }

    private onError(msg: string) {
        this.toastr.error(msg, 'Error!', {
            timeOut: 3000,
            positionClass: 'toast-bottom-right'
        });
    }

    dismissErrorMessage() {
        this.errorMessage = [];
    }

    setInitialMinAndMaxDate() {
    // Setting Minimum date
    var today = new Date();
    this.minDate = {year: today.getFullYear()-3, month: today.getMonth()+1, day: today.getDate() };
    
    // Setting Maximum date
    today = new Date();
    this.maxDate = {year: today.getFullYear(), month: today.getMonth()+1, day: today.getDate() };

    this.endDate = new Date();
    this.startDate = new Date();
    var previousDate = this.startDate.getDate() - 90;
    this.startDate.setDate(previousDate);
    }

    setInputValues(customerNumber,marketId,marketName,projectId,projectName,taskName){
        var taskRequest = new taskStatusReportRequest(customerNumber,marketId,marketName,projectId,projectName,taskName);
        
        var dateValue = this.datePipe.transform(this.startDate, "yyyy-MM-dd'T'");
        taskRequest.startDate = dateValue.concat("00:00:00.000Z");

        dateValue = this.datePipe.transform(this.endDate, "yyyy-MM-dd'T'");
        taskRequest.endDate = dateValue.concat("23:59:59.999Z");

        return taskRequest;

    }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/dashboard-reports/taskstatus-report/taskstatus-report.component.ts